// Square Web Payments SDK loader, mirrored from App.jsx's loadSquareSDK/SQUARE_CONFIG
// (not exported there, so duplicated here for the subscription pages).
export const SQUARE_CONFIG = {
  appId: process.env.REACT_APP_SQUARE_APP_ID || "sq0idp-u2eJUYg9dvUUajzAd24yLA",
  locationId: process.env.REACT_APP_SQUARE_LOCATION_ID || "L8D4WD34NRG6M",
};

const SQUARE_SDK_URL = "https://web.squarecdn.com/v1/square.js";

let _squareSdkPromise = null;
export function loadSquareSDK() {
  if (window.Square) return Promise.resolve(window.Square);
  if (!_squareSdkPromise) {
    _squareSdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = SQUARE_SDK_URL;
      script.onload = () => resolve(window.Square);
      script.onerror = () => {
        _squareSdkPromise = null;
        reject(new Error("Square SDK script failed to load"));
      };
      document.head.appendChild(script);
    });
  }
  return _squareSdkPromise;
}
